// extracted by mini-css-extract-plugin
export default {"dropdown":"Activity_dropdown__8gaCG"};